import type { IconProps } from '../icon'
import type { NotificationIntent } from './notification.types'

import { vui } from '../core'
import Icon from '../icon'
import { cs } from '../utils'
import { notificationStatusMapping, INTENT_ICON_MAP, LOADING_ICON_PROPS } from './consts'
import { useNotificationContext } from './context'

/** Displays an icon based on the status or intent within the Notification. */
export const NotificationIcon = vui<'svg', IconProps>((props, ref) => {
  const { className, alignSelf, ...rest } = props
  const mergedProps = { ...useNotificationContext(), ...props }

  const { status = '', statusMapping, intent, isLoading } = mergedProps

  const resolvedIconProps = isLoading
    ? LOADING_ICON_PROPS
    : ({ ...notificationStatusMapping, ...statusMapping }[status]?.iconProps ??
      (intent ? INTENT_ICON_MAP[intent as NotificationIntent] : undefined))

  return (
    <Icon
      alignSelf={alignSelf}
      className={cs('vui-notificationIcon', className)}
      ref={ref}
      size="md"
      variant={isLoading ? 'spinning' : 'static'}
      {...resolvedIconProps}
      {...rest}
    />
  )
})

NotificationIcon.displayName = 'NotificationIcon'

export default NotificationIcon
